import React from 'react'

const LeadsManagerTabs = ({ setSelectedTab, selectedTab, leadsCount }) => {
    return (
        <div class="nav nav-tabs border-0 !mb-2 gap-x-6" id="nav-tab" role="tablist">
            <ul className="nav gap-x-6 nav-payment-milestone flex-nowrap flex items-center" >
                <li className={`nav-item  ${selectedTab === 'Site_visit' ? 'gradient-black' : ''} ! !py-1.5 !px-3 rounded-full`}>
                    <a
                        className={`nav-link p-0 border-0 text-base ${selectedTab === 'Site_visit' ? 'text-white' : 'text-black700'} relative`}
                        onClick={() => setSelectedTab('Site_visit')}
                    >
                        Site Visits (<span className=''>{leadsCount?.site_visit}</span>)
                    </a>
                </li>
                <li className={`nav-item  ${selectedTab === 'token' ? 'gradient-black' : ''} ! !py-1.5 !px-3 rounded-full`}>
                    <a
                        className={`nav-link p-0 border-0 text-base ${selectedTab === 'token' ? 'text-white' : 'text-black700'} relative`}
                        onClick={() => setSelectedTab('token')}
                    >
                        Token
                        (<span className=''>{leadsCount?.token}</span>)
                    </a>
                </li>
                <li className={`nav-item  ${selectedTab === 'booking' ? 'gradient-black' : ''} ! !py-1.5 !px-3 rounded-full`}>
                    <a
                        className={`nav-link p-0 border-0 text-base ${selectedTab === 'booking' ? 'text-white' : 'text-black700'} relative`}
                        onClick={() => setSelectedTab('booking')}
                    >
                        Booking
                        (<span className=''>{leadsCount?.booking}</span>)
                    </a>
                </li>
                <li className={`nav-item  ${selectedTab === 'cancel' ? 'gradient-black' : ''} ! !py-1.5 !px-3 rounded-full`}>
                    <a
                        className={`nav-link p-0 border-0 text-base ${selectedTab === 'cancel' ? 'text-white' : 'text-black700'}  relative `}
                        onClick={() => setSelectedTab('cancel')}
                    >
                        Cancellations
                        (<span className=''>{leadsCount?.cancel}</span>)
                    </a>
                </li>
            </ul>
        </div>
    )
}

export default LeadsManagerTabs